module.exports = __webpack_public_path__ + "static/media/occasions-variety.7e202a95.jpg";